export default "__VITE_ASSET__20d4c4d3__"